import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import type { TGetClientOrderRes } from 'api/swagger';
import { PAGINATION_DEFAULT_LIMIT } from 'shared/constants/paginations';
import type { WithPagination } from 'shared/utils/pagination.ts';
import { preparePagination } from 'shared/utils/pagination.ts';
import type { IWithPagination } from 'types/api-query.ts';
import { CLIENT_ORDERS_GET_MANY } from '../query-keys';

interface IParams extends IWithPagination {
  search?: string;
}

export const useGetClientOrders = (params?: IParams) => {
  const { limit = PAGINATION_DEFAULT_LIMIT, page = 1, search } = params || {};

  const qs = new URLSearchParams({ limit: String(limit), page: String(page) });
  if (search) qs.set('filter[search]', search);

  return useQuery<WithPagination<TGetClientOrderRes[]>>({
    queryKey: [CLIENT_ORDERS_GET_MANY, page, limit, search],
    queryFn: async () => {
      const { data, headers } = await http.get<TGetClientOrderRes[]>(`/client-office/v1/orders?${qs.toString()}`);
      const pagination = preparePagination(headers);

      return { data, pagination };
    },
    retry: false,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    staleTime: 0,
    cacheTime: 0,
  });
};
